import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProductGates } from '../../services/workflowApi';
import '../approvals/Approvals.css';

/*
 * Approval state for one product, shown in the editor.
 *
 * Read-only on purpose: deciding belongs in the approvals queue, where the
 * approver has the gate's covered fields and the missing-value list in front of
 * them. Here it answers "what is still holding this back".
 */

const scopeLabel = (g) => {
  if (g.market_code) return g.market_code;
  if (g.locale_group && g.locale_group !== '*') return g.locale_group;
  return null;
};

export default function WorkflowPanel({ sku }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    try {
      setData(await getProductGates(sku));
    } catch {
      // The workflow tables may not be migrated yet in every environment; the
      // editor must still work without them.
      setError(true);
    }
  }, [sku]);

  useEffect(() => {
    load();
  }, [load]);

  if (error || !data) return null;

  const gates = (data.gates || []).filter((g) => g.status !== 'not_applicable');
  if (!gates.length) return null;

  return (
    <div className="apr-panel">
      <span className="apr-panel-label">Approvals</span>
      {gates.map((g) => {
        const scope = scopeLabel(g);
        return (
          <span className="apr-panel-gate" key={g.id}>
            <span className={`apr-chip ${g.status}`}>{g.status.replace('_', ' ')}</span>
            {g.gate_label}
            {scope && <span className="apr-panel-scope">{scope}</span>}
            {g.is_stale && (
              <span className="apr-chip stale" title="Values changed after approval">
                changed
              </span>
            )}
          </span>
        );
      })}
      <Link className="apr-drawer-link" to={`/pim/approvals?search=${encodeURIComponent(sku)}`}>
        {data.fully_approved ? 'All gates approved' : `${data.approved}/${data.total} approved`}
      </Link>
    </div>
  );
}
